import React, { useState, useEffect } from 'react';

/**
 * Filter bar for the after-signup survey list (069). Same au- filter shell as the survey
 * screen, but the questions are different, so the controls are too.
 *
 * The two choice filters submit an option_code (`yes`, `unclear`, …), not the label the
 * member saw — rewording a question's copy must not silently empty a saved filter.
 *
 * Setup ease is shown as a column but is deliberately NOT filterable: the question it
 * would narrow — who struggled to get started — is already answered by reading the score
 * in the table, and every low scorer is reachable through the follow-up they were asked.
 */
const EMPTY = {
  search: '', support: '', understanding: '',
  keep_using_min: '', keep_using_max: '',
  from: '', to: '',
};

export default function SignupSurveyFilters({ values, onApply, onClear, onExport }) {
  const [local, setLocal] = useState({ ...EMPTY, ...values });
  useEffect(() => { setLocal({ ...EMPTY, ...values }); }, [values]);

  const set = (k, v) => setLocal((p) => ({ ...p, [k]: v }));
  const submit = (e) => { if (e) e.preventDefault(); onApply(local); };

  return (
    <form className="au-filters sr-filters" onSubmit={submit}>
      {/* The fields wrap among themselves; the actions never leave their row. */}
      <div className="au-filters__fields">
        <div className="au-field sr-field-grow">
          <span className="au-field__label">Search</span>
          <input
            aria-label="Search user"
            className="au-input"
            placeholder="Name, email or user id"
            value={local.search}
            onChange={(e) => set('search', e.target.value)}
          />
        </div>

        <div className="au-field">
          <span className="au-field__label">Wants help</span>
          <select aria-label="Wants help" className="au-select" value={local.support} onChange={(e) => set('support', e.target.value)}>
            <option value="">All</option>
            <option value="yes">Asked us to reach out</option>
            <option value="no">Did not ask</option>
          </select>
        </div>

        <div className="au-field">
          <span className="au-field__label">Understanding</span>
          <select aria-label="Understanding" className="au-select" value={local.understanding} onChange={(e) => set('understanding', e.target.value)}>
            <option value="">All</option>
            <option value="crystal_clear">Crystal clear</option>
            <option value="mostly_clear">Mostly clear</option>
            <option value="unclear">Unclear</option>
          </select>
        </div>

        <div className="au-field">
          <span className="au-field__label">Keep using</span>
          <div className="sr-range-pair">
            <input aria-label="Min keep using" className="au-select ss-narrow" type="number" min="1" max="10" placeholder="Min" value={local.keep_using_min} onChange={(e) => set('keep_using_min', e.target.value)} />
            <span className="sr-range-dash">–</span>
            <input aria-label="Max keep using" className="au-select ss-narrow" type="number" min="1" max="10" placeholder="Max" value={local.keep_using_max} onChange={(e) => set('keep_using_max', e.target.value)} />
          </div>
        </div>

        <div className="au-field">
          <span className="au-field__label">From</span>
          <input aria-label="From date" className="au-select" type="date" value={local.from} onChange={(e) => set('from', e.target.value)} />
        </div>

        <div className="au-field">
          <span className="au-field__label">To</span>
          <input aria-label="To date" className="au-select" type="date" value={local.to} onChange={(e) => set('to', e.target.value)} />
        </div>

      </div>

      <div className="au-field au-field--actions sr-actions">
        <button type="submit" className="au-btn au-btn--primary">Apply</button>
        <button type="button" className="au-btn au-btn--ghost" onClick={() => { setLocal({ ...EMPTY }); onClear(); }}>Clear</button>
        <button type="button" className="au-btn au-btn--ghost" onClick={onExport}>⬇ Export CSV</button>
      </div>
    </form>
  );
}
